"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadataRscPermissionUtil = void 0;
exports.getWebApplicationIdStatus = getWebApplicationIdStatus;
const tslib_1 = require("tslib");
const path_1 = tslib_1.__importDefault(require("path"));
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const versionMetadata_1 = require("../../common/versionMetadata");
const telemetry_1 = require("../../common/telemetry");
const ManifestUtils_1 = require("../driver/teamsApp/utils/ManifestUtils");
class MetadataRscPermissionUtil {
    async parseManifest(ymlPath, model, props) {
        let manifestName = path_1.default.join(versionMetadata_1.MetadataV3.teamsManifestFolder, versionMetadata_1.MetadataV3.teamsManifestFileName);
        const action = model.provision?.driverDefs.find((def) => def.uses === "teamsApp/validateManifest");
        // if teamsApp/validateManifest action is defined, use the manifest file in the action
        if (action) {
            const parameters = action.with;
            if (parameters && parameters["manifestPath"]) {
                manifestName = parameters["manifestPath"];
            }
        }
        const manifestPath = path_1.default.join(path_1.default.dirname(ymlPath), manifestName);
        if (!(await fs_extra_1.default.pathExists(manifestPath))) {
            return;
        }
        try {
            const result = await ManifestUtils_1.manifestUtils._readAppManifest(manifestPath);
            if (result.isErr()) {
                return;
            }
            const webApplicationApp = result.value.webApplicationInfo?.id;
            props[telemetry_1.TelemetryProperty.WebApplicationId] = getWebApplicationIdStatus(webApplicationApp);
            const manifest = result.value;
            const summary = this.summary(manifest);
            if (summary) {
                props[telemetry_1.ProjectTypeProps.TeamsManifestVersion] = summary.version;
                props[telemetry_1.TelemetryProperty.RscApplication] = summary.rscApplication.join(",");
                props[telemetry_1.TelemetryProperty.RscDelegated] = summary.rscDelegated.join(",");
            }
        }
        catch (error) {
            return;
        }
    }
    summary(manifest) {
        const version = manifest.version;
        const rscApplication = [];
        const rscDelegated = [];
        for (const permission of manifest.authorization?.permissions?.resourceSpecific || []) {
            if (permission.type == "Application") {
                rscApplication.push(permission.name);
            }
            else {
                rscDelegated.push(permission.name);
            }
        }
        for (const permission of manifest.webApplicationInfo?.applicationPermissions || []) {
            rscApplication.push(permission);
        }
        return {
            version,
            rscApplication,
            rscDelegated,
        };
    }
}
function getWebApplicationIdStatus(id) {
    if (!id) {
        return telemetry_1.WebApplicationIdValue.None;
    }
    if (id === "${{AAD_APP_CLIENT_ID}}") {
        return telemetry_1.WebApplicationIdValue.Default;
    }
    return telemetry_1.WebApplicationIdValue.Customized;
}
exports.metadataRscPermissionUtil = new MetadataRscPermissionUtil();
//# sourceMappingURL=metadataRscPermission.js.map